import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import InputMask from 'react-input-mask';
import * as s from './../UIStyle.css';

const InputPhoneNumber = ({ changeHandler, name, mask, placeholder, ...inputParams }) => (
  <InputMask
    className={s.inputGeneral}
    onChange={e => changeHandler(name, e.target.value)}
    {...inputParams}
    placeholder={placeholder}
    mask={mask}
    maskChar=" "
    type="tel"
  />
);

InputPhoneNumber.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  mask: PropTypes.string,
  changeHandler: PropTypes.func.isRequired,
};

InputPhoneNumber.defaultProps = {
  value: '',
  mask: '+3\\8 \\099 999 99 99',
  placeholder: '+38 (0**) *** ** **',
};

export default withStyles(s)(InputPhoneNumber);



// WEBPACK FOOTER //
// ./src/shared/components/UI/InputPhoneNumber/InputPhoneNumber.js